export default "__VITE_ASSET__BESyr901__"